import styled from 'styled-components';

const Container = styled.div`
  color: rgb(54, 61, 74);
`;

export default Container;
